// src/utils/registrationFlow.js
//
// Pure helpers for the seller registration funnel. The route guards in App.js
// rely on these, so they are kept free of any Firebase / router imports and
// easy to unit test.
//
// A seller has to finish these steps, in this order, before the dashboard
// (and every other functional page) becomes reachable.

export const REGISTRATION_STEPS = [
  { key: "sellerRegistration", path: "/sellerregistration" },
  { key: "segmentRegistration", path: "/segmentregistration" },
  { key: "productRegistration", path: "/productregistration" },
];

/**
 * Where should this seller be sent right now?
 *
 * - "/login"                -> there is no session
 * - "/...registration"      -> the first unfinished registration step
 * - null                    -> registration complete, dashboard is allowed
 */
export const getNextRoute = (seller) => {
  if (!seller?.sellerId) return "/login";

  const pending = REGISTRATION_STEPS.find((step) => !seller?.[step.key]);
  if (pending) return pending.path;

  return null;
};

/**
 * First step of `requiredKeys` that is NOT finished yet, or null when all of
 * them are done. Used to keep the registration steps in order (you cannot open
 * the product step before the segment step, etc.).
 */
export const getFirstMissingStep = (seller, requiredKeys = []) => {
  if (!seller?.sellerId) return REGISTRATION_STEPS[0];

  return (
    REGISTRATION_STEPS.find(
      (step) => requiredKeys.includes(step.key) && !seller?.[step.key],
    ) || null
  );
};